import { BrowserTracing, Replay, init } from "@sentry/react";
import "@sg/i18n";
import { QueryClientProvider, ReactQueryDevtools, queryClient } from "@sg/query";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
import { AuthProvider } from "~/components/Layout/AuthProvider";
import App from "./App";
import "./styles/index.css";
import { getEnvironmentName } from "./util/environment";
import { initializeZod } from "./util/zod";

init({
  dsn: "https://9cc25c8784734f55b1d682c23cb1d0bd@o4505505972355072.ingest.sentry.io/4505520237445120",
  integrations: [
    new BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        "localhost",
        /^https:\/\/api\.devswapglobal\.com\/api/,
        /^https:\/\/api\.swapglobal\.com\/api/,
        /^https:\/\/api\.staging\-swapglobal\.com\/api/,
      ],
    }),
    new Replay(),
  ],
  environment: getEnvironmentName(),
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

initializeZod();

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools
            initialIsOpen={false}
            toggleButtonProps={{ className: "opacity-20 !w-6 !h-6" }}
            position="bottom-right"
          />
          <AuthProvider>
            <App />
          </AuthProvider>
        </QueryClientProvider>
      </QueryParamProvider>
    </BrowserRouter>
  </React.StrictMode>
);
